import "intl";
import "intl/locale-data/jsonp/en-US";

export class CurrencyService {

  public static formatCurrency(amount: number, currencyCode: string) {
    const intl = global.Intl !== undefined ? Intl : require("intl");

    const currencyStr = new intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode
    }).format(amount);

    var formattedCurrency =  this.formatNegativeNumbersWithParenthesis(currencyStr);

    return formattedCurrency ? formattedCurrency : "";
  }

  private static formatNegativeNumbersWithParenthesis(currencyStr: string): string {
    return currencyStr.indexOf("-") === 0
      ? currencyStr.replace("-", "(") + ")"
      : currencyStr;
  }
}
